import { GlBadge, GlTooltipDirective } from '@gitlab/ui';
export default {
    name: 'ProtectedBadge',
    components: {
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        tooltipText: {
            type: String,
            required: false,
            default: ''
        }
    }
};
